/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_NextInputs */

const es_home_usecases_next = /** @type {(inputs: Home_Usecases_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const en_home_usecases_next = /** @type {(inputs: Home_Usecases_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Home_Usecases_NextInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_next = /** @type {((inputs?: Home_Usecases_NextInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_NextInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_next(inputs)
	return en_home_usecases_next(inputs)
});
export { home_usecases_next as "home.usecases.next" }